export default __webpack_public_path__ + "static/media/exploded-view_labels.b5e7e7a5.png";